/**
 * Network Warning Banner
 * Displays when user is connected to wrong network
 */

import { useAccount, useChainId, useSwitchChain } from 'wagmi'
import { mainnet } from 'wagmi/chains'
import { Button } from './Button'
import { Card, CardContent } from './Card'

export function NetworkWarning() {
  const { isConnected, chain } = useAccount()
  const chainId = useChainId()
  const { switchChain, isPending } = useSwitchChain()
  
  // Check if user is on wrong network
  const isWrongNetwork = isConnected && chainId !== mainnet.id
  
  if (!isWrongNetwork) {
    return null
  }
  
  const handleSwitchNetwork = () => {
    if (switchChain) {
      switchChain({ chainId: mainnet.id })
    }
  }
  
  return (
    <div className="fixed top-20 left-0 right-0 z-40 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <Card className="border-2 border-red-500 bg-red-50">
          <CardContent className="p-m">
            <div className="flex items-center justify-between gap-m">
              <div className="flex items-center gap-m">
                <div className="w-12 h-12 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-2xl">⚠️</span>
                </div>
                <div>
                  <h3 className="font-display font-black text-heading-sm uppercase text-red-700 mb-xs">
                    Wrong Network Detected
                  </h3>
                  <p className="font-['Satoshi_Variable'] text-[14px] leading-normal text-red-600">
                    This application only works on <strong>Ethereum Mainnet</strong>. 
                    You're currently connected to: <strong>{chain?.name || 'Unknown Network'}</strong>
                  </p>
                </div>
              </div>
              <Button
                onClick={handleSwitchNetwork}
                disabled={isPending || !switchChain}
                size="md"
                className="flex-shrink-0"
              >
                {isPending ? 'Switching...' : 'Switch to Ethereum'}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

